import { call } from 'redux-saga/effects';
import { MembersResource } from '../../core/resources/members.resource';
import { PicturesResource } from '../../core/resources/pictures.resource';
import {
  IApiMultiplePictureResponse,
  IApiPictureResponse,
} from '../../models/picture/picture.types';
import { pictureNormalizer, picturesNormalizer } from './picture.normalizer';
import {
  IDeletePicturesPayload,
  IGetPicturesPayload,
  IPostPicturesPayload,
} from './picture.types';

export function* postPicture(payload: IPostPicturesPayload) {
  const response: IApiPictureResponse = yield call(
    PicturesResource.postPicture,
    payload.type,
    payload.imageBase64
  );

  return pictureNormalizer(response);
}

export function* setMainPicture(pictureId: string) {
  return yield call(PicturesResource.postMainPicture, pictureId);
}

export function* deletePicture(payload: IDeletePicturesPayload) {
  return yield call(PicturesResource.deletePicture, payload.id);
}

export function* getPictures(payload: IGetPicturesPayload) {
  const response: IApiMultiplePictureResponse = yield call(
    MembersResource.getPictures,
    payload.id
  );

  return picturesNormalizer(response);
}
